{
  "FILTER": {
    "AI_PROMPT": "AI филтър",
    "TITLE": "Филтрирай разговорите",
    "SUBTITLE": "Add your filters below and hit 'Apply filters' to cut through the chat clutter.",
    "EDIT_CUSTOM_FILTER": "Edit Folder",
    "CUSTOM_VIEWS_SUBTITLE": "Add or remove filters and update your folder.",
    "ADD_NEW_FILTER": "Add filter",
    "FILTER_DELETE_ERROR": "Oops, looks like we can't save nothing! Please add at least one filter to save it.",
    "SUBMIT_BUTTON_LABEL": "Прилагане на филтри",
    "UPDATE_BUTTON_LABEL": "Update folder",
    "CANCEL_BUTTON_LABEL": "Отмени",
    "CLEAR_BUTTON_LABEL": "Clear filters",
    "FOLDER_LABEL": "Folder Name",
    "TEAMS_LABEL": "Споделяне с",
    "PARENT_FOLDER_LABEL": "Родителска папка",
    "NO_PARENT_FOLDER": "Без родителска папка",
    "BACKGROUND_COLOR_LABEL": "Цвят на фона",
    "COLOR_LABEL": "Цвят",
    "SELECT_COLOR": "Изберете цвят",
    "CLEAR_SELECTION": "Изчистване на избора",
    "SORT_BY_LABEL": "Сортиране по",
    "FOLDER_QUERY_LABEL": "Folder Query",
    "EMPTY_VALUE_ERROR": "Изисква се стойност.",
    "TOOLTIP_LABEL": "Филтрирай разговорите",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "И",
      "OR": "ИЛИ"
    },
    "INPUT_PLACEHOLDER": "Enter value",
    "OPERATOR_LABELS": {
      "present": "Присъства",
      "not_present": "Не присъства",
      "present_with_answer": "Присъства с отговор",
      "present_without_answer": "Присъства без отговор",
      "equal_to": "Равно на",
      "not_equal_to": "Различно от",
      "does_not_contain": "Не съдържа",
      "is_present": "Присъства",
      "is_not_present": "Не присъства",
      "is_greater_than": "Is greater than",
      "is_less_than": "Is lesser than",
      "is_greater_than_or_equal": "По-голямо или равно на",
      "is_less_than_or_equal": "По-малко или равно на",
      "newer_than_days": "По-ново от x дни (включително)",
      "older_than_days": "По-старо от x дни (включително)",
      "starts_with": "Starts with",
      "equalTo": "Равно на",
      "notEqualTo": "Различно от",
      "contains": "Съдържа",
      "doesNotContain": "Не съдържа",
      "isPresent": "Присъства",
      "isNotPresent": "Не присъства",
      "isGreaterThan": "Is greater than",
      "isLessThan": "Is lesser than",
      "isGreaterThanOrEqual": "По-голямо или равно на",
      "isLessThanOrEqual": "По-малко или равно на",
      "startsWith": "Starts with"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "True",
      "FALSE": "False"
    },
    "ATTRIBUTES": {
      "STATUS": "Статус",
      "ASSIGNEE_NAME": "Assignee name",
      "INBOX_NAME": "Inbox name",
      "TEAM_NAME": "Team name",
      "CONVERSATION_IDENTIFIER": "Conversation identifier",
      "CAMPAIGN_NAME": "Campaign name",
      "LABELS": "Етикети",
      "BROWSER_LANGUAGE": "Browser language",
      "PRIORITY": "Priority",
      "COUNTRY_NAME": "Country name",
      "REFERER_LINK": "Референтна връзка",
      "CUSTOM_ATTRIBUTE_LIST": "List",
      "CUSTOM_ATTRIBUTE_TEXT": "Text",
      "CUSTOM_ATTRIBUTE_NUMBER": "Number",
      "CUSTOM_ATTRIBUTE_LINK": "Link",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Checkbox",
      "CREATED_AT": "Създаден в",
      "LAST_ACTIVITY": "Last activity",
      "LAST_CUSTOMER_MESSAGE_AT": "Последно съобщение от клиент",
      "PHONE_CALL": "Телефонно обаждане",
      "RATING": "Оценка",
      "CSAT": "CSAT"
    },
    "PHONE_CALL_TYPES": {
      "INBOUND": "Входящо",
      "OUTBOUND": "Изходящо",
      "MISSED": "Пропуснато",
      "UNHANDLED_MISSED": "Необработено пропуснато"
    },
    "RATING_TYPES": {
      "UP": "Палец нагоре",
      "DOWN": "Палец надолу"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Изисква се стойност",
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Стойността трябва да е между 0 и 998",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standard filters",
      "ADDITIONAL_FILTERS": "Additional filters",
      "CUSTOM_ATTRIBUTES": "Custom attributes"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "Do you want to save this filter?",
        "LABEL": "Name this filter",
        "PLACEHOLDER": "Name your filter to refer it later.",
        "ERROR_MESSAGE": "Name is required.",
        "SAVE_BUTTON": "Save filter",
        "CANCEL_BUTTON": "Отмени",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Folder created successfully.",
          "ERROR_MESSAGE": "Error while creating folder."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment created successfully.",
          "ERROR_MESSAGE": "Error while creating segment."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Edit folder",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "Грешка при обновяване на папката."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "Delete filter",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Потвърди изтриването",
            "MESSAGE": "Are you sure to delete the filter ",
            "YES": "Yes, delete",
            "NO": "No, keep it"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Folder deleted successfully.",
          "ERROR_MESSAGE": "Error while deleting folder."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment deleted successfully.",
          "ERROR_MESSAGE": "Error while deleting segment."
        }
      }
    }
  }
}
